import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'hub-checkbox',
  templateUrl: './hub-checkbox.component.html',
  styleUrls: ['./hub-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HubCheckboxComponent),
      multi: true
    }
  ]
})

export class HubCheckboxComponent implements ControlValueAccessor {

  @Input() label: string = '';
  @Input() labelExtra: string = '';
  @Input() disabled: boolean = false;
  @Input() style: 'primary' | 'secondary' = 'primary';

  @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();

  value: boolean = false;

  // Keep a reference to the original onChange from forms
  private formOnChange = (value: any) => {};
  private formOnTouched = () => {};

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.formOnChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.formOnTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get checkboxClass(): string {
    return this.style;
  }

  clicked(event: Event): void {
    if (this.disabled) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    this.value = !this.value;
    
    // Notify Angular forms
    this.formOnChange(this.value);
    this.formOnTouched();
    
    // Emit your custom change event
    this.change.emit(this.value);
  }
}
